import ConfigData from 'config/ConfigData';

const MembershipOfAPPGsFilters = [
  {
    name: 'APPGs',
    pages: ['Stakeholders'],
    type: 'membership',
    subtype: 'MembershipOfAPPGs',
    searchState: 'SeneddOrHolyroodCondition',
    filterName: 'allPartyGroups',
    options: [],
    prefix: 'appg',
    optionSelected: '',
    configHidden: ConfigData?.filters?.allPartyGroups?.configHidden,
  },
  {
    name: 'APPGs (officers)',
    pages: ['InfluenceContacts'],
    type: 'membership',
    subtype: 'MembershipOfAPPGs',
    searchState: 'SeneddOrHolyroodCondition',
    filterName: 'allPartyGroups',
    options: [],
    prefix: 'appg',
    optionSelected: '',
    configHidden: ConfigData?.filters?.allPartyGroups?.configHidden,
  },
];

// Devolved cross-party groups; NI calls them All Party Groups, but there is no Stormont legislature option yet
const MembershipOfCrossPartyGroupsFilters = [
  {
    name: 'Cross Party Groups',
    pages: ['Stakeholders'],
    type: 'membership',
    subtype: 'MembershipOfCrossPartyGroups',
    searchState: 'DevolvedCondition',
    filterName: 'crossPartyGroups',
    options: [],
    prefix: 'cpg',
    optionSelected: '',
    configHidden: ConfigData?.filters?.crossPartyGroups?.configHidden,
  },
];

export { MembershipOfCrossPartyGroupsFilters };
export default MembershipOfAPPGsFilters;
